import { Cookies } from "@story/story_assets";

const COOKIE_NAME = "cookies_consent";

export class CookiesConsent {
	static onShow = null;
	static onClose = null;

	constructor() {
		this.load();
		if (!this.isDone()) {
			this.show();
		}
	}

	isDone() {
		return this.allowed !== null;
	}

	load() {
		let allowed = Cookies.get(COOKIE_NAME);
		if (allowed) {
			allowed = allowed.split(",");
		}
		else if (allowed == "") {
			allowed = [];
		}
		else {
			allowed = null;
		}
		this.allowed = allowed;
	}

	save() {
		Cookies.set(COOKIE_NAME, this.allowed.join(","), 365);
	}

	show() {
		if (CookiesConsent.onShow) {
			CookiesConsent.onShow(this);
		}
	}

	close() {
		if (CookiesConsent.onClose) {
			CookiesConsent.onClose(this);
		}
	}

	acceptSelected() {
		let allowed = [];

		let checkboxes = document.querySelectorAll("input[type='checkbox'][name^='cookies_consent[']");
		for (let checkbox of checkboxes) {
			let category = checkbox.name.match(/\[([a-zA-Z0-9_]+)\]$/)[1];
			if (checkbox.checked) {
				allowed.push(category);
			}
		}
		this.change(allowed);
	}

	rejectAll() {
		this.change([]);
	}

	change(newValue) {
		let oldValue = this.allowed;
		this.allowed = newValue;
		this.save();

		if (oldValue && newValue && JSON.stringify(oldValue) != JSON.stringify(newValue)) {
			oldValue.sort();
			newValue.sort();

			let changes = {
				current: newValue,
				previous: oldValue,
				newlyAccepted: newValue.filter(function(x) { return !oldValue.includes(x); }),
				newlyRejected: oldValue.filter(function(x) { return !newValue.includes(x); })
			};

			document.trigger("cookiesconsent:change", { allowed: this.allowed, changes: changes });
		}
		else if (oldValue === null && newValue !== null) {
			document.trigger("cookiesconsent:change", { allowed: this.allowed, changes: {} });
		}

		this.close();
	}

	static getInstance() {
		if (!this.instance) {
			this.instance = new CookiesConsent();
		}
		return this.instance;
	}
};

export function onCookiesConsentReady(callback) {
	let instance = CookiesConsent.getInstance();
	if (instance.isDone()) {
		callback(instance.allowed);
	}

	document.addEventListener("cookiesconsent:change", function(event) {
		callback(event.detail.allowed, event.detail.changes);
	});
}

// *************************************************************************
// Události
// *************************************************************************

document.addEventSelectorListener("click", "[data-cookies-consent]", function(event, target) {
	event.preventDefault();
	let action = target.getAttribute("data-cookies-consent");

	let instance = CookiesConsent.getInstance();
	switch (action) {
		case "rejectAll":
			instance.rejectAll();
			break;
		case "save":
			instance.acceptSelected();
			break;
		default:
			instance.change(action.split(","));
			break;
	}
});
